// extracted by mini-css-extract-plugin
export default {"root":"NPQTfiORjhcgMHRZvlvS","danger":"ZzrPO8cOMZBw_8gvRB7T","select":"bUzpmutTnodG4D47xBoj","placeHolderShimmer":"dBuhkmvrUi6RGulU1zvx"};